import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import './AdminTabNav.css';

const TAB_USERS = 'users';
const TAB_GLOBAL = 'global-settings';
const TAB_PRICING = 'pricing-settings';
const TAB_PHONE_POOL = 'phone-pool';
const TAB_PRIVACY_TERMS = 'privacy-terms';
const TAB_GA_ANALYTICS = 'ga-analytics';

const AdminTabNav: React.FC = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const path = location.pathname;
  const currentTab = searchParams.get('tab') || TAB_USERS;

  const tabs: { id: string; label: string }[] = [
    { id: TAB_USERS, label: 'Users' },
    { id: TAB_GLOBAL, label: 'Global Settings' },
    { id: TAB_PRICING, label: 'Pricing Settings' },
    { id: TAB_PHONE_POOL, label: 'Phone Pool' },
    { id: TAB_PRIVACY_TERMS, label: 'Privacy / Terms & Conditions' },
    { id: TAB_GA_ANALYTICS, label: 'Site Analytics' },
  ];

  // On Feedbacks and Tickets pages, don't show the tab bar at all
  const isFeedbacksOrTickets = path === '/admin/feedbacks' || path === '/admin/tickets';
  if (isFeedbacksOrTickets) {
    return null;
  }

  const handleTabClick = (e: React.MouseEvent, tabId: string) => {
    e.preventDefault();
    if (tabId === TAB_USERS) {
      setSearchParams({});
    } else {
      setSearchParams({ tab: tabId });
    }
  };

  const getHref = (tabId: string) => {
    return tabId === TAB_USERS ? '/admin' : `/admin?tab=${tabId}`;
  };

  return (
    <nav className="admin-page-tabs" aria-label="Admin sections">
      {tabs.map(({ id, label }) => {
        const isActive = path === '/admin' && currentTab === id;
        const href = getHref(id);
        return (
          <Link
            key={id}
            to={href}
            onClick={(e) => handleTabClick(e, id)}
            className={`admin-page-tab ${isActive ? 'admin-page-tab-active' : ''}`}
          >
            {label}
          </Link>
        );
      })}
    </nav>
  );
};

export default AdminTabNav;
export { TAB_USERS, TAB_GLOBAL, TAB_PRICING, TAB_PHONE_POOL, TAB_PRIVACY_TERMS, TAB_GA_ANALYTICS };
